import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import {
  HydratedRecommendation,
  RecommendationQueryParams
} from "../../recommendation.types";

export const requestGetResellerRecommendations = async (
  id: string,
  params: RecommendationQueryParams
): Promise<HydratedRecommendation[]> => {
  return await instance.get(
    `${ApiRoutesRecommendation.RecommendReseller}/${encodeURIComponent(id)}`,
    { params }
  );
};
